import React from 'react';
import { Dropdown } from "react-bootstrap";

export const StatusDropdownFilter = ({tabSelected, statusArr, handleSelection, dataSetter, data}) => {

    // eslint-disable-next-line no-unused-vars
    const colors = {
      "Solicitud pendiente": "red",
      "Pendiente de recolección": "red",
      "Todos": "blue"
    }
    if(tabSelected==="pending"){
    return (
      <div className="px-2 border-0">
        {statusArr.map((statusItem, index) => (
          <Dropdown.Item
            key={index}
            eventKey={index}
            // eslint-disable-next-line no-script-url
            href={"javascript:void(0)"}
            onClick={() => handleSelection(statusItem, data, dataSetter)}
          >
            {statusItem}
          </Dropdown.Item>
        ))}

      </div>
    );
    }
}